<template>
  <div class="user-wrap">
    <common-bg-plate>
      <change-chain></change-chain>
      <div class="user-content">
        <user></user>
        <!-- <action-bar>
          <btn-style :btn-list="btnList"></btn-style>
        </action-bar>
        <el-row :gutter="16">
          <el-col v-for="(item,i) in list" :key="item + i" :span="6">
            <div class="user-card">
              <div class="user-card-head">
                <div class="user-head-name">用户名：{{ item.name }}</div>
                <div class="user-status">使用中</div>
              </div>
              <div class="user-info">
                <div v-for="(ele, index) in userInfo" :key="ele + index" class="item-line">
                  <div class="item-label">{{ ele.label }}：</div>
                  <div class="item-text">{{ item[ele.value] }}</div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row> -->
      </div>
    </common-bg-plate>
  </div>
</template>
<script>
import changeChain from '../privacyComputing/components/changeChain.vue'
import user from '../blockchain/user/index.vue'
export default {
  components: {
    changeChain,
    user
  },
  data() {
    return {
      btnList: [
        {
          btnContent: '新建',
          click: () => {
            return this.handleCreate()
          }
        },
        {
          btnContent: '合约下载',
          click: () => {
            return this.createTask()
          }
        }
      ],
      userInfo: [
        { label: '属性集合', value: 'des' },
        { label: '注册时间', value: 'des' }
      ],
      list: [
        {
          name: '张三',
          time: '2025-01-23',
          des: '一甲医院，三甲医院，泌尿科'
        },
        {
          name: '张三',
          time: '2025-01-23',
          des: '一甲医院，三甲医院，泌尿科'
        },
        {
          name: '张三',
          time: '2025-01-23',
          des: '一甲医院，三甲医院，泌尿科,一甲医院，三甲医院，泌尿科'
        },
        {
          name: '张三',
          time: '2025-01-23',
          des: '一甲医院，三甲医院，泌尿科'
        },
        {
          name: '张三',
          time: '2025-01-23',
          des: '一甲医院，三甲医院，泌尿科'
        }
      ]
    }
  },
  mounted() {},
  methods: {
    getList() {},
    handleCreate() {
      this.$router.push({
        path: '/encryption-create'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'user-wrap',
  (
    --user-wrap-body-card-head: rgba(48, 60, 101, 1),
    --user-wrap-body-card-body: #232d51,
    --user-wrap-body-card-head-font-color: #fff,
    --user-wrap-body-card-head-user-status: #45c2ff,
    --user-wrap-body-card-body-line-label-color: rgba(255, 255, 255, 0.6),
    --user-wrap-body-card-body-line-text-color: #fff,
    --user-wrap-body-card-border-color: rgba(48, 60, 101, 1)
  ),
  (
    --user-wrap-body-card-head: #45c2ff,
    --user-wrap-body-card-body: #fff,
    --user-wrap-body-card-head-font-color: #fff,
    --user-wrap-body-card-head-user-status: #fff,
    --user-wrap-body-card-body-line-label-color: rgba(90, 105, 115, 1),
    --user-wrap-body-card-body-line-text-color: rgba(25, 34, 39, 1),
    --user-wrap-body-card-border-color: rgba(235, 235, 235, 1)
  )
);
.user-wrap {
  @include adaptation(
    (
      --user-wrap-body-padding: 24px 20px,
      --user-wrap-body-card-head-padding: 12px 16px,
      --user-wrap-body-card-font-size: 14px,
      --user-wrap-body-card-margin-bottom: 16px,
      --user-wrap-body-card-body-padding: 20px 16px 10px,
      --user-wrap-body-card-body-line-margin: 10px
    )
  );
  --user-wrap-min-height: var(--base-main-router-body-avaliable-height);
  .common-bg-plate {
    min-height: var(--user-wrap-min-height);
    .user-content {
      padding: var(--user-wrap-body-padding);
      .user-card {
        font-size: var(--user-wrap-body-card-font-size);
        margin-bottom: var(--user-wrap-body-card-margin-bottom);
        .user-card-head {
          background: var(--user-wrap-body-card-head);
          padding: var(--user-wrap-body-card-head-padding);
          color: var(--user-wrap-body-card-head-font-color);
          display: flex;
          align-items: center;
          justify-content: space-between;
          .user-status {
            color: var(--user-wrap-body-card-head-user-status);
          }
        }
        .user-info {
          background: var(--user-wrap-body-card-body);
          padding: var(--user-wrap-body-card-body-padding);
          border: 1px solid var(--user-wrap-body-card-border-color);
          border-top: 0;
          .item-line {
            display: flex;
            align-items: center;
            margin-bottom: var(--user-wrap-body-card-body-line-margin);
            .item-label {
              flex-shrink: 0;
              color: var(--user-wrap-body-card-body-line-label-color);
            }
            .item-text {
              color: var(--user-wrap-body-card-body-line-text-color);
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
  }
}
</style>
